import SimplifiedDestinationMap from "@/components/home/SimplifiedDestinationMap";

const DestinationsSection = () => {
  return (
    <section className="py-16 sm:py-24 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 sm:mb-6">
            Les destinations ouvertes
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed px-4">
            Explorez nos destinations populaires, optimisées pour le télétravail 
            et l'équilibre vie pro-vie perso
          </p>
        </div>

        <div className="w-full max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl border overflow-hidden">
            <div className="h-[400px] sm:h-[500px] w-full">
              <SimplifiedDestinationMap />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;